import { IFeaturedImage, IPlatform } from '@/shared/types/existing-brands';

import { BreakpointsType } from '@/shared/types/typings';
import { FAQType } from '../types/subscription';
import { IMembershipCard } from '@/shared/types/existing-brands';
import { STATIC_FILE_URL } from '@/shared/constants';

export const FEATURE_BRANDS: IFeaturedImage[] = [
  { title: 'House Plant', link: `${STATIC_FILE_URL}/bd3d7c55cf646c988d10892201b2264b.png`, width: 250, height: 290 },
  { title: 'Bad Mouth', link: `${STATIC_FILE_URL}/4d5750bfe1acce76c72f90c26125cad2.png`, width: 250, height: 290 },
  { title: 'CBUMFITNESS', link: `${STATIC_FILE_URL}/e852689e60da6f8bbaa28fb5e8e74829.png`, width: 250, height: 290 },
  { title: 'Arrae', link: `${STATIC_FILE_URL}/1196a4f7e374be784d8d39e311f39845.png`, width: 250, height: 290 },
  { title: 'Curie', link: `${STATIC_FILE_URL}/0db718edd3d6ed8666ce912e6e9a8d33.png`, width: 250, height: 290 },
  { title: 'Wellthy', link: `${STATIC_FILE_URL}/0912c2d5c4e3eeff29398f29e581a4af.png`, width: 250, height: 290 },
];

export const EXISTING_BRANDS_FEATURED_IN_CONTENT: IFeaturedImage[] = [
  {
    title: 'As featured in',
    link: `${STATIC_FILE_URL}/c5d527b188a35e79cec7eaf2b98ea434.png`,
    width: 104,
    height: 19,
  },
  {
    title: 'Tech Crunch 1',
    link: `${STATIC_FILE_URL}/d65e5b8989922fa0f958538d63bab6cd.svg`,
    width: 138,
    height: 20,
  },
  {
    title: 'CNBC 1',
    link: `${STATIC_FILE_URL}/685fc58e16b7ac581252464f998b0925.png`,
    width: 40,
    height: 32,
  },
  {
    title: 'Business Insider 1',
    link: `${STATIC_FILE_URL}/a7235f4c38c1500aa22b8894c2ead6a8.png`,
    width: 77,
    height: 24,
  },
  {
    title: 'Forbes 1',
    link: `${STATIC_FILE_URL}/4b7c20eb379918c86e22bc003e8d4ab3.png`,
    width: 61,
    height: 16,
  },
  {
    title: 'Modern Retail 1',
    link: `${STATIC_FILE_URL}/dc81365e388b399ba01a157697239ce5.png`,
    width: 152,
    height: 20,
  },
  {
    title: 'New Bloomberg 1',
    link: `${STATIC_FILE_URL}/4a75f21285efb990682c7f36160b063f.png`,
    width: 130,
    height: 24,
  },
  {
    title: 'Tech Crunch 2',
    link: `${STATIC_FILE_URL}/d65e5b8989922fa0f958538d63bab6cd.svg`,
    width: 138,
    height: 20,
  },
  {
    title: 'CNBC 2',
    link: `${STATIC_FILE_URL}/685fc58e16b7ac581252464f998b0925.png`,
    width: 40,
    height: 32,
  },
  {
    title: 'Business Insider 2',
    link: `${STATIC_FILE_URL}/a7235f4c38c1500aa22b8894c2ead6a8.png`,
    width: 77,
    height: 24,
  },
  {
    title: 'Forbes 2',
    link: `${STATIC_FILE_URL}/4b7c20eb379918c86e22bc003e8d4ab3.png`,
    width: 61,
    height: 16,
  },
  {
    title: 'Modern Retail 2',
    link: `${STATIC_FILE_URL}/dc81365e388b399ba01a157697239ce5.png`,
    width: 152,
    height: 20,
  },
  {
    title: 'New Bloomberg 2',
    link: `${STATIC_FILE_URL}/4a75f21285efb990682c7f36160b063f.png`,
    width: 130,
    height: 24,
  },
  {
    title: 'Tech Crunch 3',
    link: `${STATIC_FILE_URL}/d65e5b8989922fa0f958538d63bab6cd.svg`,
    width: 138,
    height: 20,
  },
  {
    title: 'CNBC 3',
    link: `${STATIC_FILE_URL}/685fc58e16b7ac581252464f998b0925.png`,
    width: 40,
    height: 32,
  },
  {
    title: 'Business Insider 3',
    link: `${STATIC_FILE_URL}/a7235f4c38c1500aa22b8894c2ead6a8.png`,
    width: 77,
    height: 24,
  },
  {
    title: 'Forbes 3',
    link: `${STATIC_FILE_URL}/4b7c20eb379918c86e22bc003e8d4ab3.png`,
    width: 61,
    height: 16,
  },
  {
    title: 'Modern Retail 3',
    link: `${STATIC_FILE_URL}/dc81365e388b399ba01a157697239ce5.png`,
    width: 152,
    height: 20,
  },
  {
    title: 'New Bloomberg 3',
    link: `${STATIC_FILE_URL}/4a75f21285efb990682c7f36160b063f.png`,
    width: 130,
    height: 24,
  },
];

export const PLATFORMS: IPlatform[] = [
  {
    title: 'Visitor ID',
    description: 'Build your email list from visitors browsing your website and increase revenue by 66%.',
    logo: {
      title: 'Visitor ID',
      link: `${STATIC_FILE_URL}/d63fe6c472bb274d5ac92af3a40e246d.png`,
      width: 246,
      height: 221,
    },
    linkTo: 'email-capture',
    style: { color: `var(--pietra-blue)` },
  },
  {
    title: 'Influencer Marketing',
    description: 'Build a powerful affiliate marketing program to grow sales, track performance, and payouts.',
    logo: {
      title: 'Influencer Marketing',
      link: `${STATIC_FILE_URL}/0d5263a6d5bc16685468628e3a6f5eb8.png`,
      width: 286,
      height: 210,
    },
    linkTo: 'affiliate-marketing',
    style: { color: `#4B4B3B` },
    cardStyle: { width: '100%' },
  },
];

export const MEMBERSHIP_CARDS: IMembershipCard[] = [
  {
    title: 'Vetted global manufacturers',
    description: 'Pre-negotiated rates for all our members and software to manage it all.',
    image: {
      link: `${STATIC_FILE_URL}/5304a3ce90bbc8abd91b52cc700cfbbe.png`,
      title: 'Vetted global manufacturers',
      width: 536,
      height: 220,
    },
  },
  {
    title: '$1.50 fulfillment (unlimited picks)',
    description: 'Our members-only 3PL offers the best fulfillment rates to ship globally.',
    image: {
      link: `${STATIC_FILE_URL}/8e4f56116feb8a5152259dfbd99c0def.png`,
      title: '$1.50 fulfillment (unlimited picks)',
      width: 310,
      height: 233,
    },
  },
  {
    title: 'Streamline your operations',
    description: 'Avoid digging through emails, Pietra centralizes all of your communications & invoices. ',
    image: {
      link: `${STATIC_FILE_URL}/9a5cee3e6c416b9cce920fed224390cf.png`,
      title: 'Streamline your operations',
      width: 265,
      height: 220,
    },
  },
  {
    title: 'White-glove services available',
    description:
      'Book 1:1 time with production specialists, fulfillment wizards, and e-commerce professionals at any time.',
    image: {
      link: `${STATIC_FILE_URL}/31152fe70d0fa7dd556bd885af861c3d.png`,
      title: 'White-glove services available',
      width: 315,
      height: 210,
    },
  },
];

const existingBrandsSignupImage = `${STATIC_FILE_URL}/481d293a72f988bf05c680e028f2e107.png`;
export const SIGN_UP_LOGOS: Record<BreakpointsType, IFeaturedImage> = {
  '300': {
    width: 368,
    height: 549,
    title: 'Arrae',
    link: existingBrandsSignupImage,
  },
  '640': {
    width: 592,
    height: 549,
    title: 'Arrae',
    link: existingBrandsSignupImage,
  },
  '768': {
    width: 704,
    height: 549,
    title: 'Arrae',
    link: existingBrandsSignupImage,
  },
  '1024': {
    width: 460,
    height: 549,
    title: 'Arrae',
    link: existingBrandsSignupImage,
  },
  '1280': {
    width: 576,
    height: 714,
    title: 'Arrae',
    link: existingBrandsSignupImage,
  },
};

export const CASE_STUDY_LINK: string =
  'https://docs.google.com/presentation/d/e/2PACX-1vSn0UMnZkSXfYtMrNyA2TyZ4-7bNJTTMP449iBgK4ALAlBt8YpuD81GtO1CvYXfSz-Ad--CkYDINj23/pub?start=false&loop=false&delayms=3000&slide=id.g133e6f18103_0_0';

export const EXISTING_BRANDS_FAQ: FAQType[] = [
  {
    question: 'Is Pietra for existing brands and retailers?',
    answer:
      'Yes, Pietra is for existing brands and retailers just as much as it is for new brands. Existing brands and retailers can take advantage of a vetted network of high quality manufacturers to easily introduce new product lines, manage suppliers more efficiently, and streamline logistics, from factory floor to end destination. Pietra can help you streamline your logistics and sell on more sales channels.',
  },
  {
    question: 'How does Pietra help me source products & packaging for my business?',
    answer:
      "You will have access to Pietra's entire network of suppliers. These are high quality, vetted suppliers that have worked with the best brands in the world, from Nike to Gucci and more! There are hundreds of suppliers in each category that will allow you to easily get connected and start developing products right away. In addition to the product suppliers, you'll find a large network of packaging suppliers and freelancers to assist you with any design needs. With everything centralized through Pietra, managing your suppliers, invoices and shipments has never been easier.",
  },
  {
    question: 'Can I move over to Pietra 3PL and take advantage of low prices?',
    answer:
      "Absolutely! Pietra's fulfillment center is available to all entrepreneurs using our sourcing network and even those working with out of network suppliers. After subscribing, you'll want to fill out the inventory intake form to let us know what you'd like to ship. Afterwards, a Pietra Specialist will be in touch to help you coordinate the shipment.",
  },
  {
    question: 'Who is Pietra for?',
    answer:
      'Pietra is for Creators who are passionate about creating a unique custom product. There are 300,000+ entrepreneurs on the platform all united by their interest of creating products. Join the community of inspirational Creators on Pietra by unlocking full access to the platform.',
  },
  {
    question: 'How can Pietra help me if I already own a business?',
    answer:
      "Pietra's technology helps both new and established businesses streamline their operations. We connect all the dots to make ordering inventory, product assembly, storage, e-commerce and order fulfillment as easy as possible for you. Using Pietra allows businesses to focus more time and energy on building long lasting customer relationships and marketing, while relying on Pietra to handle their logistics and day to day operations.",
  },
  {
    question: 'How does Pietra make launching a product line easier?',
    answer:
      "Pietra has done the hard work of vetting hundreds of manufacturers so you don't have to. You can work with high quality manufacturers that have a strong track record. We've also connected all the dots for you to make launching your product line easier than ever. You will have your product and packaging components shipped to Pietra's Warehouse. Our assembly experts will video call you and you'll watch in real time as they assemble your products according to your instructions. We'll update your inventory and connect your website or provide you with a super easy shop to set up, and you can then start selling immediately. By having everything connected by Pietra, you won't have to worry about what happens next - we've got you covered!",
  },
  {
    question: 'How does low cost order fulfillment, storage, and assembly work?',
    answer:
      "You can decide to ship things to Pietra's Fulfillment Center to take advantage of low cost kitting, assembly, global order fulfillment, storage, and photography. You can order these services directly from inside the Pietra Creator Hub.",
  },
  {
    question: "Can I use only a few services Pietra's Platform offers?",
    answer:
      "Yes! You don't have to use all of Pietra's services. You can just use the sourcing marketplace to create products, or send existing products to a Pietra Fulfillment Center to ship orders that are placed on your existing website.",
  },
  {
    question: 'Can I work with my existing suppliers?',
    answer:
      'You certainly can. You can invite your supplier to Pietra and a specialist will help you train your supplier on the best ways to ship products and manage payments, wherever they are in the world.',
  },
  {
    question: 'How does Pietra help grow sales?',
    answer:
      "Pietra allows you to list your products on the Creator Marketplace or additional sales channels like Instagram Shopping, Google Shopping, and different wholesale websites. You can take advantage of this service if you are using Pietra's Fulfillment Services.",
  },
  {
    question: 'Do you vet all suppliers and freelancers on the platform?',
    answer:
      'All the suppliers on the platform are handpicked and vetted by a team of specialists. They often work with top brands like Nike, KKW Beauty, Zara, Gucci, and more. You get access to the best in the world at pre-negotiated rates.',
  },
  {
    question: 'Why is Pietra the smartest way to launch my e-commerce brand?',
    answer:
      "Pietra offers a bundle of services that are all connected together which makes it incredibly easy to launch and scale your e-commerce brand. Pietra provides a production marketplace with hundreds of vetted suppliers who work with some of the top brands. Pietra also provides ultra low cost storage, fulfillment, and assembly so you don't have to stitch together all those services. Oh yeah, Pietra also allows you to set up a website or connect your Shopify to the platform so you can manage your entire operations from one place.",
  },
  {
    question: 'What am I paying for?',
    answer: `Pietra will cost you $49/mo for the Pietra Essentials membership to launch and run your business. Included in your monthly fee is your personalized business plan that will give you a step-by-step guide to launching your first product line. It comes packed with supplier recommendations, free tools, and a wealth of knowledge that would take you months to acquire. You can cancel at any time, before or after your launch, but since Pietra is a digital platform we do not authorize refunds on our monthly subscription.`,
  },
  {
    question: 'Does Pietra have a supplier for my product line?',
    answer:
      "Pietra has over 500 manufacturers on the platform that span 25 product categories, from clothing to candles to beauty and much more. There are thousands of products that you can customize and hundreds of suppliers to work with to create a completely unique product from scratch. We'll even suggest manufacturers for you to work with in your Creator Blueprint, which is a step by step guide on how to launch your product line. We would love to help you start creating your product line today.",
  },
];
